import { Box, Container } from "@chakra-ui/react"
import { Headline } from "@/-components/Headline"
import { AnimatedScrollSection } from "@/-components/AnimatedScrollSection"
import { data } from "./_data"

export const UserFlowsEditor = () => {
    return (
        <Box py={{ base: 0, lg: 12 }} px={{ base: 6, lg: 0 }}>
            <Box
                as="section"
                w="full"
                mx="auto"
                align="center"
                mt={12}
            >
                <Container w="full" maxW="7xl" mb={{ base: 0, lg: 24, '2xl': 0 }}>
                    <Headline
                        heading="Create complex user flow diagrams easily with Rarchy"
                        subheading="Our free user flows and flowchart diagram maker is quick to setup and start using straight away, but if you need a helping hand, follow the steps below."
                        textAlign="center"
                        mx="auto"
                        mb={{ base: 6, lg: 24, '2xl': 0 }}
                    />
                    <AnimatedScrollSection data={data} />
                </Container>
            </Box>
        </Box>
    )
}